import ApiBase from 'Services/Api/ApiBase';

class ServiceUsers extends ApiBase {
    route = '/service-users/service-users';
};

export default new ServiceUsers();